import { render } from "./ScreenSliderPuzzle.vue?vue&type=template&id=2fa73934&scoped=true&ts=true"
import script from "./ScreenSliderPuzzle.vue?vue&type=script&lang=ts"
export * from "./ScreenSliderPuzzle.vue?vue&type=script&lang=ts"

import "./ScreenSliderPuzzle.vue?vue&type=style&index=0&id=2fa73934&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa73934"]])

export default __exports__